import React from "react";

import { useTranslation } from "react-i18next";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/src/components/ui/card";

import { formatQuotaDuration } from "../../utils/liveQuota";

import type { JSX } from "react";

import type { LiveQuotaSummary } from "../../utils/liveQuota";

interface LiveQuotaCardProps {
  quota: LiveQuotaSummary | null;
}

function LiveQuotaCard({ quota }: LiveQuotaCardProps): JSX.Element | null {
  const { t } = useTranslation("editor-content");

  if (!quota) return null;

  return (
    <Card className="gap-3 py-4">
      <CardHeader className="flex flex-row items-center justify-between gap-2 px-4">
        <CardTitle>{t("liveRegie_quotaTitle")}</CardTitle>
        <span className="text-muted-foreground text-sm">
          {t("liveRegie_quotaAvailable", {
            available: formatQuotaDuration(quota.availableBeforeSeconds),
          })}
        </span>
      </CardHeader>
      <CardContent className="px-4 text-sm">
        <p>
          {t(
            quota.isEnough
              ? "liveRegie_quotaConsumes"
              : "liveRegie_quotaRequires",
            { needed: formatQuotaDuration(quota.neededSeconds) },
          )}
        </p>
      </CardContent>
    </Card>
  );
}

export default LiveQuotaCard;
